import { IProduct } from '@kizi/comparator-core';
import { Image, P } from '@kizi/core-components';
import React, { useState } from 'react';
import { Window } from '../../Window';
import { SolarPanelModalOverview } from './SolarPanelModalOverview';

interface ProductModalProps {
  data: IProduct;
  buttonText?: string;
}

export const ProductModal: React.FC<ProductModalProps> = ({
  data,
  buttonText = 'Open Modal',
}) => {
  const { image, provider } = data;

  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(!isOpen);

  return (
    <>
      <P
        onClick={handleOpen}
        variant="footnoteImportant"
        color="main.1"
        css={{ cursor: 'pointer' }}
        display="inline-block"
      >
        {buttonText}
      </P>

      <Window
        type="modal"
        onClose={handleOpen}
        show={isOpen}
        showIcon
        title={
          <Image
            src={image}
            width="100%"
            height="100%"
            maxWidth={150}
            alt={`logo-${provider.name}`}
          />
        }
        modalProps={{
          show: isOpen,
          modalContainerDivProps: {
            width: '80% !important',
            maxWidth: '760px',
          },
          // Desktop
          children: <SolarPanelModalOverview data={data} />,
        }}
      >
        {/* Mobile */}
        <SolarPanelModalOverview data={data} />
      </Window>
    </>
  );
};
